import React,{useState,useEffect} from 'react';
import CustomModal from './CustomModal';
import { useTranslation } from 'react-i18next';
import constants from '../../common/constants';
import {GetUserInfo} from '../../services/api';

const Navbar = (props) => {
   const { t, i18n } = useTranslation();
   const isArabic = i18n.language === 'ar';
   const [isOpen, setIsOpen] = useState(false);
   const [ibwpage,setIbwPage]= useState('');
   const [viewport, setViewport] = useState('');
   const [isNavbarOpen, setIsNavbarOpen] = useState(false);
   const operator = localStorage.getItem('currentOperator');
   const operatorDemos = ["DEMO","OOREDOO_ALGERIA"];
   const isOperator = operatorDemos.includes(operator);
   const m = localStorage.getItem('m');
   const aiDemo = props.hostname === "aidemo"
   const isVideo = props.isVideo ? props.isVideo : false ;

  //  const [isDailyPlan,setIsDailyPlan] = useState(false);


    // useEffect(()=>{
    //     if (props.user_id){
    //        GetUserInfo(props.user_id)
    //        .then((response)=>{
    //          const data = response.data.user_info
    //          if(data){
    //           setIsDailyPlan(true)
    //          }
    //        }).catch((error)=>{console.error('Error:', error);})
    //     }

    // },[props.user_id])

    const toggleNavbar = () => {
      setIsNavbarOpen(!isNavbarOpen);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setIsOpen(false); 
        if (window.location.hash) {
          window.history.replaceState(null, null, window.location.pathname + window.location.search);
        }
    };

    const getLanguageName = (languageCode) => {
      const languageNames = {
        'en': 'EN',
        'ar': 'AR',
        'fr': 'FR',
        'de':'DE',
        'ro':'RO',
        'pl':'PL',
      };
      
      return languageNames[languageCode] || languageCode;
    };

    // const [isToggled, setIsToggled] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const user_id = props.user_id;

    // const handleClick = () => {
    //   setIsToggled(prevState => !prevState);
    // };

    const handleShowModal = () => {
      if(isOperator){
        setIbwPage(true)
        setShowModal(true);
        document.body.classList.add('no-scroll'); 
      }
      if(constants.Operators[operator].Sub_link){
        window.location.href = constants.Operators[operator].Sub_link
      }  
    };

    const handleCloseModal = () => {
      setShowModal(false);
      document.body.classList.remove('no-scroll'); // Enable scrolling
    };

    useEffect(() => {
      function handleResize() {
          // Get the width of the viewport
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    
          // Update the state based on the viewport width
          if (viewportWidth < 991) {
            setViewport('mobile');
          } else {
            setViewport('desktop');
          }
        }
    
        // Call handleResize initially and add event listener for window resize
        handleResize();
        window.addEventListener('resize', handleResize);
    
        // Cleanup the event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
      }, []); // Empty dependency array ensures this effect runs only once on mount

      const languages = constants.Operators[operator]?.AVAILABLE_LANGUAGES || [];
  
    return (
      <header>
      <nav className="navbar navbar-dark navbar-expand-lg poppins-medium pt-3">
        <div className="container">
          <a className="navbar-brand width-logo" href="/">
            <img src="../assets/images/logo.png" alt="" className="navbar-logo"/>
          </a>

          {props.navlinks && (
            <>
              {viewport == 'desktop' && (
                <nav className={`navbar navbar-expand-lg mx-auto`}>
                  <div className="container">
                    <div className={`collapse navbar-collapse`} id="navbarSupportedContent">
                      <ul className="navbar-nav mx-auto">
                        <li className="nav-item text-light px-3">
                          <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="#about">{t('nav.about')}</a>
                        </li>
                        <li className="nav-item text-light px-3">
                          <a className={`nav-link text-light nav-hover  ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="#categories">{t('nav.categories')}</a>
                        </li>
                        <li className="nav-item text-light px-3">
                          <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="#keyfigures">{t('nav.keyfigures')}</a>
                        </li>
                        {aiDemo && (
                          <li className="nav-item text-light px-3">
                            <span className='d-flex'>
                              <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="#chatbot">{t('nav.mycoach')}</a>
                              <sup className='pt-2'><img src="../assets/images/star.png" width="15px"/></sup>
                            </span>
                          </li>
                        )}
                     
                        {/* {isDailyPlan && (
                          <li className="nav-item text-light px-3">
                            <span className='d-flex'>
                              <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="/workoutplan">{t('nav.dailyplan')}</a>
                            </span>
                          </li>
                        )} */}
                      </ul>
                    </div>
                  </div>
                </nav>
              )}
            </>
          )}
          
          <div className='pt-2'>
            <form className="px-1 d-flex flex-row">
                {!isVideo && (
                  <div className="dropdown">
                    <button type="button" className="btn btn-link nav-link text-light" onClick={toggleDropdown} aria-expanded={isOpen ? 'true' : 'false'}>
                      <span>{getLanguageName(i18n.language) == 'en-US' || getLanguageName(i18n.language) == 'en-GB' || getLanguageName(i18n.language) == 'fr-FR' || getLanguageName(i18n.language) == 'en-AU' ? 'EN'  : getLanguageName(i18n.language)}</span>
                      <span className='dropdown-toggle px-2'></span>
                    </button>
                    <div className={`dropdown-menu ${isOpen ? ' show' : ''}`}>
                      {languages.map((lang) => (
                        <button key={lang.CODE} className={`dropdown-item ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} onClick={() => changeLanguage(lang.CODE)}>
                          {lang.CODE.toUpperCase()}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {!props.BodyWeightCalculatorpage && (
                  <>
                      {props.hostname === "ro" ? (
                         <>
                          {m && (
                            <a href='/ibw'><button type="button" className={`btn sign-up-button ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{t('nav.CalculateIBW')}</button></a>
                          )}
                         </>
                      ):(
                        <>
                          {user_id ? (
                            <a href='/ibw'><button type="button" className={`btn sign-up-button ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{t('nav.CalculateIBW')}</button></a>
                          ):(
                            <>
                              <button type="button" className={`btn sign-up-button  ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} onClick={handleShowModal}>{t('nav.CalculateIBW')}</button>
                              <CustomModal user_id={user_id} setUserId={props.setUserId} showModal={showModal} ibwpage={ibwpage} handleClose={handleCloseModal}/>
                            </>
                          )}
                        </>
                      )}
                        
                  </>
                )}
              
            </form>
          </div>
          {props.navlinks && (
            <>
              <button
                className={`navbar-toggler navbar-toggler-light justify-content-end ${isNavbarOpen ? 'change' : ''}`}
                type="button"
                onClick={toggleNavbar}
                aria-controls="navbarSupportedContent"
                aria-expanded={isNavbarOpen ? 'true' : 'false'}
                aria-label="Toggle navigation"
              >
                <div className="bar1"></div>
                <div className="bar2"></div>
                <div className="bar3"></div>
              </button>
            </>
          )}
        </div>
      </nav>
      {props.navlinks && (
        <>
          {viewport == 'mobile' && (
            <div className='position-relative'> 
              <nav className={`navbar navbar-expand-lg ${isNavbarOpen && !isArabic  ? 'navbar-mobile' : ''} ${isNavbarOpen && isArabic ? 'navbar-mobile-arabic' : ''}`}>
                <div className="container">
                  <div className={`collapse navbar-collapse ${isNavbarOpen ? 'show' : 'd-lg-none'}`} id="navbarSupportedContent">
                    <ul className={`navbar-nav mx-auto  ${isArabic ? 'nav-pad-right-arabic' : ''}`}>
                      <li className="nav-item text-light px-3">
                        <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold ' : 'avenir-regular'}`} href="#about">{t('nav.about')}</a>
                      </li>
                      <hr style={{ borderColor: "#e6e6e6" }}></hr>
                      <li className="nav-item text-light px-3">
                        <a className={`nav-link text-light nav-hover  ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="#categories">{t('nav.categories')}</a>
                      </li>
                      <hr style={{ borderColor: "#e6e6e6" }}></hr>
                      <li className="nav-item text-light px-3">
                        <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="#keyfigures">{t('nav.keyfigures')}</a>
                      </li>
                      {aiDemo && (
                        <>
                        <hr style={{ borderColor: "#e6e6e6" }}></hr>
                        <li className="nav-item text-light px-3">
                          <span className='d-flex justify-content-center'>
                              <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="#chatbot">{t('nav.mycoach')}</a>
                              <sup className='pt-2'><img src="../assets/images/star.png" width="15px"/></sup>
                            </span>
                        </li>
                        </>
                      )}
                      {/* {isDailyPlan && (
                        <>
                        <hr style={{ borderColor: "#e6e6e6" }}></hr>
                        <li className="nav-item text-light px-3">
                          <span className='d-flex justify-content-center'>
                              <a className={`nav-link text-light nav-hover ${isArabic ? 'notokufi-bold' : 'avenir-regular'}`} href="/workoutplan">{t('nav.dailyplan')}</a>
                            </span>
                        </li>
                        </>
                      )} */}
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          )}
        </>

      )}


    </header>
    );
  };
  
  export default Navbar;